import { render, staticRenderFns } from "./OficialDocumentTableRow.vue?vue&type=template&id=02b39587&"
import script from "./OficialDocumentTableRow.vue?vue&type=script&lang=js&"
export * from "./OficialDocumentTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports